import { CIcon } from '~/icons/types'

export const ciChatBubble: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 1.436c-6.065 0-11 4.154-11 9.28a8.558 8.558 0 0 0 2.752 6.133l-1.8 4.332a1 1 0 0 0 1.419 1.253L8.54 19.48c1.126.316 2.29.477 3.46.476 6.065 0 11-4.153 11-9.26s-4.935-9.26-11-9.26Zm0 16.52a10.79 10.79 0 0 1-3.286-.51 1.01 1.01 0 0 0-.8.084l-2.992 1.71.957-2.3a1 1 0 0 0-.312-1.176A6.565 6.565 0 0 1 3 10.701c0-4 4.038-7.26 9-7.26s9 3.256 9 7.26c0 4.003-4.038 7.255-9 7.255Z'
    },
    {
      d:
        'M12.889 12H8a1 1 0 0 0 0 2h4.889a1 1 0 0 0 0-2ZM16 8H8a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'chat-bubble',
  type: 'regular'
}
